import { emailApiClient } from './emailApiClient';

export interface TransferEmailResponse {
  contactId: string;
}

export const TRANSFER_LIMIT_REACHED_MESSAGE =
  'Maximum number of transfers reached - Handle the email yourself or call a captain.';

interface ApiProblemDetails {
  detail?: string;
}

export const transferEmail = async (
  contactId: string,
  queueId: string,
  comment?: string,
  contactFlowId?: string
): Promise<TransferEmailResponse> => {
  if (!contactId || !queueId) {
    throw new Error('contactId and queueId are required to transfer an email');
  }

  const response = await emailApiClient('/transfer', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ contactId, queueId, contactFlowId, comment })
  });

  if (response.status === 422) {
    throw new Error(TRANSFER_LIMIT_REACHED_MESSAGE);
  }

  if (!response.ok) {
    const errorBody = (await response.json().catch(() => undefined)) as ApiProblemDetails | undefined;
    throw new Error(errorBody?.detail ?? `API responded with status ${response.status}`);
  }

  return (await response.json()) as TransferEmailResponse;
};
